"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = __importStar(require("query-string"));
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var unfetch_1 = __importDefault(require("unfetch"));
var subscriptions_api_1 = require("../../../../misc/subscriptions-api");
var modal_1 = __importDefault(require("../../../../plugins/modal"));
var loading_modal_1 = __importDefault(require("../../components/loading_modal"));
var index_1 = require("../../index");
var useEffect = React.useEffect, useState = React.useState;
var Loyalty = function () {
    var _a = __read(useState(true), 2), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = __read(useState(true), 2), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = __read(useState(''), 2), percentageDiscount = _c[0], setPercentageDiscount = _c[1];
    var _d = __read(useState(), 2), submitError = _d[0], setSubmitError = _d[1];
    var queryClient = (0, react_query_1.useQueryClient)();
    var history = (0, react_router_dom_1.useHistory)();
    var location = (0, react_router_dom_1.useLocation)();
    var queryArgs = queryString.parse(location.search);
    var ltyk = queryArgs.ltyk, bid = queryArgs.bid;
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customerHash, clientArgs, res, discount, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    customerHash = (0, index_1.getCustomerHash)();
                    clientArgs = (0, subscriptions_api_1.getClientArgs)({ customerHash: customerHash, path: '/lty' });
                    return [4 /*yield*/, (0, unfetch_1.default)(clientArgs.uri, {
                            method: 'POST',
                            body: JSON.stringify({ ltyk: ltyk, bid: bid }),
                            headers: __assign(__assign({}, clientArgs.headers), { 'Content-Type': 'application/json' }),
                        })
                        // the result will be a discount object
                    ];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()
                        // update the modal
                    ];
                case 2:
                    discount = (_a.sent()).discount;
                    // update the modal
                    setPercentageDiscount(discount.value.toString());
                    // now update the graphql cache
                    return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                case 3:
                    // now update the graphql cache
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setSubmitError(e_1);
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // as soon as the component loads, submit the request
    useEffect(function () {
        if (!ltyk || !bid)
            return;
        submit();
    }, []);
    var handleClose = function () {
        setIsModalOpen(false);
        history.replace('/');
    };
    if (!ltyk || !bid)
        return null;
    if (isSubmitting || submitError) {
        return React.createElement(loading_modal_1.default, { isLoading: isSubmitting, error: submitError });
    }
    // borrow this from the retention offer
    var discountImage = window.accountApp.settings.retention.discountImage;
    return (React.createElement(React.Fragment, null,
        React.createElement(modal_1.default, { isOpen: isModalOpen, handleClose: handleClose },
            React.createElement("div", { className: 'padding-4 padding-bottom-9 text-center', style: { maxWidth: 480 } },
                React.createElement("p", null, "Woohoo!"),
                React.createElement("img", { src: discountImage }),
                React.createElement("div", { className: 'h3 margin-vertical-4 font-bold' },
                    "We've applied ",
                    percentageDiscount,
                    "% off your next order"),
                React.createElement("button", { onClick: handleClose, className: 'cell medium-6 button large wisteria padding-vertical-5' }, "Go to my bundle")))));
};
exports.default = Loyalty;
